export const ACTION_SET_USER = 'SET_USER'
export const ACTION_SET_IS_MOBILE = 'SET_IS_MOBILE'
export const ACTION_SET_LANGUAGE = 'SET_LANGUAGE'
// Company list
export const ACTION_SET_COMPANY_LIST = 'SET_COMPANY_LIST'
export const ACTION_SET_COMPANY_INDUSTRY_SELECTION = 'SET_COMPANY_INDUSTRY_SELECTION'
export const ACTION_SET_FOLLOW = 'SET_FOLLOW'
export const ACTION_SET_COMPANY_FOLLOW = 'SET_COMPANY_FOLLOW'
export const ACTION_SET_SEARCH_ROBOT = 'ACTION_SET_SEARCH_ROBOT'
